module.exports = __webpack_public_path__ + "img/am.57c71f36.svg";